import { Flex, Layout, Typography } from "antd";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useGetPendingCorrections } from "@hooks";
import { PendingCorrectionsTable } from "../../components/grading/PendingCorrectionsTable";
import { GradingStatusEnum } from "../../types/grading/GradingStatus";
import { useState } from "react";

export const PendingCorrectionsPage = () => {
  const { t } = useTranslation();
  const [statusFilter, setStatusFilter] = useState<GradingStatusEnum | undefined>(undefined);
  const { data, isLoading } = useGetPendingCorrections(statusFilter);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Layout>
        <Flex justify="space-between" align="center">
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: 3,
                backgroundColor: "#F1B80E",
                borderRadius: 100,
                marginRight: 12,
              }}
            />
            <Typography.Title level={2} style={{ margin: 0 }}>
              {t("grading.pendingCorrections")}
            </Typography.Title>
          </div>
        </Flex>

        <div
          style={{
            boxShadow: "rgba(0, 0, 0, 0.16) 1px 0px 5px",
            borderRadius: "8px",
            marginTop: 12,
            backgroundColor: "white",
            padding: "16px",
          }}
        >
          <PendingCorrectionsTable 
            data={data || []} 
            loading={isLoading}
            onStatusFilterChange={setStatusFilter}
          />
        </div>
      </Layout>
    </motion.div>
  );
};
